module.exports = __webpack_public_path__ + "static/img/b545faeb9f8cdd3960488b948973a20.3eb5369f.jpg";